var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 123.51 123.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.51,
    height: 123.51,
    rx: 5.72,
    ry: 5.72,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.38,123.38c-6.55,0-13.1,0-19.65,0-15.34-15.26-30.68-30.51-46.02-45.77,21.89-21.89,43.78-43.79,65.67-65.68v111.45Z",
    style: {
      fill: "#d2d8ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.73,123.38c-8.04,0-16.09,0-24.13,0-11.29-11.27-22.57-22.53-33.86-33.8,3.99-3.99,7.98-7.98,11.97-11.97,15.34,15.26,30.68,30.51,46.02,45.77Z",
    style: {
      fill: "#f5f6fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.61,123.38H11.95c11.26-11.27,22.53-22.53,33.79-33.8,11.29,11.27,22.57,22.53,33.86,33.8Z",
    style: {
      fill: "#5992cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.95,123.38H0v-12.04C37.12,74.23,74.23,37.12,111.35,0h12.04v11.93C86.24,49.08,49.09,86.23,11.95,123.38Z",
    style: {
      fill: "#fbdc65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,111.35V0h111.35C74.23,37.12,37.12,74.23,0,111.35Z",
    style: {
      fill: "#21a263"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.66,43.35c-.11,5.73-1.52,10.39-3.79,14.82-2.37,4.63-5.33,8.85-8.76,12.76-2.85,3.24-5.94,6.23-9.24,9-.99.83-1.28.84-2.26,0-4.75-4.05-9.14-8.46-12.83-13.51-3.2-4.39-5.98-9.02-7.59-14.27-.82-2.66-1.35-5.38-1.31-8.15.11-7.45,3.01-13.61,8.86-18.3,2.76-2.21,5.89-3.67,9.35-4.37,7.51-1.51,14.15.32,19.88,5.36,3.78,3.32,6.13,7.53,7.16,12.44.34,1.61.42,3.27.53,4.21Zm-22.93-8.31c-4.87,0-8.78,3.91-8.79,8.8,0,4.91,3.94,8.91,8.78,8.92,4.85,0,8.79-4,8.78-8.91,0-4.89-3.91-8.8-8.78-8.8Z",
    style: {
      fill: "#e74b4f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.d26e81a5615db1b0ce5ad636b530a54d.svg";
export { ForwardRef as ReactComponent };